import { all, call, takeLatest } from 'redux-saga/effects';
import { addRadarRange, deleteRadarRange, getRadarRanges } from '../../api/radar';
import { RADAR_ACTION_TYPES } from '../actions/radar.actions';


function* loadRadarRanges(action) {
  const { resolve, reject } = action;
  try {
    const { data } = yield call(getRadarRanges);
    resolve({ items: data });
  } catch (e) {
    reject(e.response.data);
  }
}

function* deleteRadarRanges(action) {
  const { resolve, reject, payload } = action;
  try {
    const data = yield call(deleteRadarRange, payload);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

function* createRadarRanges(action) {
  const { resolve, reject, payload } = action;
  try {
    const data = yield call(addRadarRange, payload);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

export default function* () {
  yield all([
    takeLatest(RADAR_ACTION_TYPES.LOAD_RADAR_RANGES, loadRadarRanges),
    takeLatest(RADAR_ACTION_TYPES.DELETE_RADAR_RANGES, deleteRadarRanges),
    takeLatest(RADAR_ACTION_TYPES.CREATE_RADAR_RANGES, createRadarRanges),
  ]);
}